import { WalletMultiButton } from "@demox-labs/aleo-wallet-adapter-reactui";
import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import React, { Suspense } from "react";
import logo from "../../assets/gif/aleoLoader.gif";

const Hop = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Loader = () => {
  const LoaderContainer = styled.div(() => ({
    display: "inline-block",
    position: "relative",
    width: "80px",
    height: "80px",
    "& div": {
      boxSizing: "border-box",
      display: "block",
      position: "absolute",
      width: "64px",
      height: "64px",
      margin: "8px",
      border: "8px solid #B1321E",
      borderRadius: "50%",
      animation: `${Hop} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite`,
      borderColor: " #B1321E transparent transparent transparent",
      "&:nth-of-type(1)": {
        animationDelay: "-0.45s",
      },
      "&:nth-of-type(2)": {
        animationDelay: "-0.3s",
      },
      "&:nth-of-type(3)": {
        animationDelay: "-0.15s",
      },
    },
  }));

  return (
    <>
      <LoaderContainer>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </LoaderContainer>
    </>
  );
};
